import { connect } from "react-redux";
import { Dispatch } from "redux";
import { closeModal, RootState, setIsUserApproved } from "../../../store";
import { MODAL_TYPE } from "../../../utils";
import { AddAndSignUpUser } from "./AddAndSignUpUser";

type StateProps = {
  visibility: boolean;
  roleCode: string;
};
type DispatchProps = {
  handleClose: () => void;
  setIsUserApproved: () => void;
};
export type SignUpUserProps = StateProps & DispatchProps;

const mapStateToProps = (state: RootState): StateProps => {
  return {
    visibility: state.ui.modal[MODAL_TYPE.ADD_AND_SIGN_UP_USER],
    roleCode: state.authUser.user.role.code,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  handleClose: () => {
    dispatch(closeModal(MODAL_TYPE.ADD_AND_SIGN_UP_USER));
  },
  setIsUserApproved: () => {
    dispatch(setIsUserApproved(true));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndSignUpUser);
